export const septaTurnoutInspectionFormInstructions = {
  list: "ol",
  type: "A",
  className: "septa-to-inst-main",
  items: [
    {
      title: "TURNOUTS TO BE INSPECTED",
      data: "This form is to be used for the monthly inspection of all turnouts.",
    },
    {
      title: "NOTATION",
      list: "ul",
      className: "septa-to-nots-main",
      items: [
        {
          title: "Detail conditions shall be indicated as follows:",
          list: "ol",
          className: "septa-to-nots",
          items: [
            { title: ["G (Good)", "No unsatisfactory conditions."] },
            {
              title: [
                "F (Fair)",
                "Safely serving intended function but less than satisfactory conditions indicate repairs or replacement should be scheduled.",
              ],
            },
            { title: ["P (Poor)", "Defect that does not require a change in class."] },
            { title: ["D (Defect)", "Defect that requires immediate action."] },
          ],
        },
        {
          title:
            "A remark number can be used in conjunction with the above legend to direct information to the additional reporting space available on the bottom of the form. ie.: P(1), D(2), etc.",
        },
      ],
    },
    {
      title: "CORRECTIVE ACTION",
      data:
        'Any adjustments as necessary shall be made in conjunction with the inspection and "adj" indicated in proper column. In the case of a "D" defect, action taken shall be noted in Column 23.',
    },
    {
      title: "DETAILS OF INSPECTION",
      list: "ol",
      className: "septa-to-inst-cols",
      items: [
        { title: ["Column 1", "Indicate the name of interlocking where the inspection is being performed."] },
        { title: ["Column 2", "Show location of turnout by number."] },
        { title: ["Column 3", "Switch, stock rail and lead designate Normal and Reverse."] },
        { title: ["Column 4", 'Record actual opening found at switch point, if adjusted, mark "adj."'] },
        {
          title: [
            "Column 5",
            "Include surface wear and any or all parts which may affect safe and proper operation of switch rails, such as; bolts, rivets, clips, and fastenings including cotter pins; chipping. wearing, line of interference of switch rail facing against stock rail.",
          ],
        },
        {
          title: [
            "Column 6",
            "Include fastenings to switch clips, cotter pins, boring of switch rods, etc. including insulation where applicable. Record any other damage to switch rod which may affect safe and proper operation of switch in remarks space.",
          ],
        },
        {
          title: [
            "Column 7",
            "Include contact of brace with stock rail and plate condition, condition of plates, bolts, and nutlocks. Any bolt retightening that was required must be recorded in Column 23.",
          ],
        },
        {
          title: [
            "Column 8",
            "Compare surface wear of stock rail to surface wear of switch point. Check flow of stock rail metal interfering with proper bearing of switch rail and point against stock rail. Indicate action taken. Indicate if stock rail is notproperly bent ahead of switch point on curved side stock rail",
          ],
        },
        {
          title: [
            "Column 9",
            "Switch lock must be in proper working order and fastened by a chain to the timber or stand so that the switch can only be locked in the normal position. If not applicable, enter N/A",
          ],
        },
        {
          title: [
            "Column 10",
            "Latches (koopers) should be securly fastened and in proper working order. Latches should be tested for wear to ensure that the switch cannot be opened without removing the switch lock. If latches are not applicable, enter N/A",
          ],
        },
        {
          title: [
            "Column 11",
            "Switch position indicators (targets) shall indicate the correct position, be in working order, and visible.",
          ],
        },
        {
          title: [
            "Column 12",
            "(X) Record actual gauge at bend of stock rall ahead of point. (Y) Record actual gage into switch rall two (2) feet from point of switch and record for normal and reverse move on corresponding line.",
          ],
        },
        {
          title: [
            "Column 13",
            "Record track gauge found from point of swich thru to the last long timber. Record gauge taken for normal and reverse move and record on the corresponding line.",
          ],
        },
        {
          title: [
            "Column 14",
            "Record condition of frog and all components, including plates. Indicate any grinding or welding required in remarks at the bottom of the form.",
          ],
        },
        {
          title: [
            "Column 15",
            "Record track gauge taken at frog six (6) inchesback from point. Record gauge taken for normal and reverse move and record on the corresponding line.",
          ],
        },
        { title: ["Column 16", "Record condition of guard rail and components."] },
        {
          title: [
            "Column 17",
            'Measure guard rall "check" gauge from wheel flange face of guard rail to gauge line of existing frog point. Record guard rail "check" gauge for normal and reverse move on the corresponding line.',
          ],
        },
        {
          title: [
            "Column 18",
            'Measure back to back "face" gauge from the guarding face of the guard rail to a corresponding frog wing rail face (or adjacent guard rail). Record back to back "face" gauge for normal and reverse move on the corresponding line.',
          ],
        },
        { title: ["Column 19", "Indicate whether timbers are sound and properly tamped, or in such a condition that renewals are required."] },
        { title: ["Column 20", "Indicate condition of rail anchors that are required to hold all components in relative position."] },
        {
          title: [
            "Column 21",
            "Derail should be in proper working order, spiked and clearly visible, free of any obstructions. If no derail is required, enter as N/A.",
          ],
        },
        {
          title: [
            "Column 22",
            "Indicate track surface condition and note defects in: twist, variation (spirals) or difference (tangent/curve bodies); crosslevel / super elevation deviation; or profile.",
          ],
        },
        { title: ["Column 23", "Record immediate remedial action take for specific defects, if any."] },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/SEPTA/TrackSectionTurnoutAndSpecialWorkInspectionForm/instructionList.js